import styled from 'styled-components';

export default styled.div`
  width: 100%;
  font-size: 0.875rem;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);

  @media print {
    display: none;
  }
`;
